// All query tiles are fetched at zoom:5 independent of viewport zoom
// eslint-disable-next-line import/prefer-default-export
export const TARGET_ZOOM = 5;
export const LONG_PRESS_TIME = 500;
